/**
 * Returns a formatted money amount (with the currency symbol)
 *
 * @param      {<type>}  amount
 * @param      {string}  currency
 * @param      {<type>}  [opts={}] Can be used to specify how many decimal we want
 */
export function formatMoney(amount, currency, opts = {}) {
  return Number(amount).toLocaleString(window._locale, { style: "currency", currency: getCurrencyOrDefault(currency), ...opts });
}

export function initForAlpine(Alpine) {
  Alpine.magic("money", () => ({
    format(amount, currency, opts) {
      return formatMoney(amount, getCurrencyOrDefault(currency), opts);
    },
  }));
}

function getCurrencyOrDefault(currency) {
  if (currency) {
    return currency;
  }
  /**
   * Please always provide an explicit currency, even if it's the academy's default currency. Letting this function decide the currency
   * is a bad practice.
   *
   * See https://github.com/A-World-For-Us/digiforma/pull/8768#discussion_r1998514659
   */
  console.warn("No currency provided, defaulting to academy's default currency");
  currency = window._money.code;
  return currency;
}
